__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "RepslyWebApplication";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "19.2.21", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(5399), __webpack_require__.e(1303), __webpack_require__.e(4349)]).then(() => (() => (__webpack_require__(31303))))));
			register("@angular/common", "19.2.21", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(5399), __webpack_require__.e(1163), __webpack_require__.e(6730)]).then(() => (() => (__webpack_require__(31163))))));
			register("@angular/core", "19.2.21", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(9285)]).then(() => (() => (__webpack_require__(89285))))));
			register("@angular/material/dialog", "19.2.19", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(5399), __webpack_require__.e(1697), __webpack_require__.e(152)]).then(() => (() => (__webpack_require__(152))))));
			register("@angular/material/snack-bar", "19.2.19", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(5399), __webpack_require__.e(1697), __webpack_require__.e(6205), __webpack_require__.e(5660)]).then(() => (() => (__webpack_require__(56205))))));
			register("@angular/router", "19.2.21", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(5399), __webpack_require__.e(3092), __webpack_require__.e(189)]).then(() => (() => (__webpack_require__(33092))))));
			register("@ngx-translate/core", "14.0.0", () => (Promise.all([__webpack_require__.e(3613), __webpack_require__.e(2409), __webpack_require__.e(5399), __webpack_require__.e(7376)]).then(() => (() => (__webpack_require__(97376))))));
			register("rxjs/operators", "6.6.7", () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(3895), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(13895))))));
			register("rxjs", "6.6.7", () => (Promise.all([__webpack_require__.e(8398), __webpack_require__.e(7691), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(7691))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};